export default __webpack_public_path__ + "static/media/footer.93d40ae7.less";